export const EINVOICE = 'EINVOICE';
export const EARCHIVE = 'EARCHIVE';
export const ESMM = 'ESMM';
export const EMM = 'EMM';
export const EIRSALIYE = 'EIRSALIYE';
